<script>
		import {user, view} from "../client.svelte.js";
		import {docs} from "../core.js";
		import {marked} from "marked";
		import ActionCard from "./ActionCard.svelte";
		import SkillCard from "./SkillCard.svelte";

		/** floating: shows a help button at the bottom right (for screens without navigation bar) **/
		let {floating = false} = $props()

		let currentDoc = $derived(view.help)
		let relevantDocs = $derived(docs.filter(entry => entry?.section === view.help?.section))
		let currentIndex = $derived(relevantDocs.findIndex(entry => entry.topic === view.help?.topic))

    let longpressTimer, longpressTriggered = false

		// $inspect(`HELP - current doc `, currentDoc)

		function toggle_help(e) {
				if (longpressTriggered) {
						longpressTriggered = false
						return
				}
				view.turnon_help()
		}

		function update_docs(e) {
				e.preventDefault()
				if (!['Pierre', 'Natalie', 'Martin', 'Florian'].includes(user.ID))  return
				view.show_dialog('updatedocs', {})
		}

		function start_longpress(e) {
				longpressTriggered = false
				longpressTimer = setTimeout(() => {
						longpressTriggered = true
						update_docs(e)
				}, 800)
		}

		function cancel_longpress(e) {
				clearTimeout(longpressTimer)
		}

		function next_topic(e) {
				e.stopPropagation()
				view.help = relevantDocs[currentIndex + 1]
		}

		function prev_topic(e) {
				e.stopPropagation()
				view.help = relevantDocs[currentIndex - 1]
		}

</script>

<!-------------------------------- HELP -------------------------------------->


{#if view.help}
	<aside id='help' class="help">

		<button id='help-close' class="close fa icon-square-xmark" onclick={() => view.turnoff_help()}></button>
		{#if view.help.TYPE === 'Power' || view.help.TYPE === 'Ability'}
			<div class="action-card">
				<ActionCard action={view.help} />
			</div>
		{:else if view.help.TYPE === 'Skill'}
			<div class="skill-card">
				<SkillCard skill={view.help} />
			</div>
		{:else}
			<div class="documentation">
				<h2 class="info-title">{currentDoc.title}</h2>
				<div class="doc-text">
					{@html marked(currentDoc.text ?? "")}
				</div>
			</div>
		{/if}
		<menu class="doc-nav">
			{#if currentIndex > 0}
				<li>
					<button class="btn-primary btn-primary-circle icon-angles-left" disabled={currentIndex === 0} onclick={prev_topic}>
						<span class="full-label">{relevantDocs[currentIndex - 1].title}</span>
						<span class="short-label">Zurück</span>
					</button>
				</li>
			{:else}
				<p></p>
			{/if}
			{#if currentIndex < relevantDocs.length - 1}
				<li>
					<button class="btn-primary btn-primary-circle icon-angles-right" disabled={currentIndex === relevantDocs.length - 1} autofocus onclick={next_topic}>
						<span class="full-label">{relevantDocs[currentIndex + 1].title}</span>
						<span class="short-label">Weiter</span>
					</button>
				</li>
			{:else}
				<p></p>
			{/if}
		</menu>

	</aside>
{:else if floating}
	<img class="help-button" data-help="helpbutton" class:helping={view.help} src="/static/buttons/help.png" onclick={toggle_help} oncontextmenu={update_docs}
			 onpointerdown={start_longpress} onpointerup={cancel_longpress} onpointerleave={cancel_longpress} >
{/if}


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	#help
		grid-area: help

	.help
		position: relative
		height: 99%
		container-type: inline-size

	.close
		position: absolute
		right: 16px
		top: 8px
		font-size: larger
		color: lightgray
		z-index: 10

	.close:hover
		color: lightcoral

	.action-card
		align-self: center
		justify-self: center

	.documentation
		//height: 100%
		margin: 8px
		border: solid gray
		border-radius: 14px
		padding: 8px
		display: grid
		grid-template-rows: auto auto 64px
		flex-direction: column
		background-color: colors.$grey-85
		color: colors.$black
		font-size: larger
		//@include vertical

		.doc-text
			overflow-y: auto
			scrollbar-width: none
			&::-webkit-scrollbar
				display: none

	.doc-nav
		display: flex
		flex-wrap: wrap
		justify-content: space-evenly
		padding-inline: 0

		.short-label
			display: none

	@container (max-width: 300px)
		.doc-nav .full-label
			display: none
		.doc-nav .short-label
			display: inline


	/* ---- HELP BUTTON ---- */

	.help-button
		position: fixed
		z-index: 10
		bottom: 16px
		right: 24px
		width: 48px
		filter: brightness(90%)

		&::after
			position: relative
			top: -8px
			margin: 0 0 0 10px
			content: "\f05a"
			font-family: 'Font Awesome 6 Free'
			font-size: smaller
			font-weight: normal
			font-style: normal
			color: colors.$primary-100
			text-decoration: none
			cursor: help

	.help-button.helping
		color: colors.$primary-100
		filter: brightness(130%)

</style>
